import gql from 'graphql-tag';

export const SEND_EMAIL_MUTATION = gql`
  mutation sendEmail($params: SendEmail) {
    sendEmail(params: $params) {
      success
      message
    }
  }
`;

export const EMAIL_TEMPLATES = {
  TEST_ASSIGNED: {
    subject: "Admission Test Details - Rizee College",
    message: `Hello {student_name},
    
Your admission test has been assigned. Please find your login details below:

URL: https://exams.rizee.in
Username: {username}
Password: {password}

Best of luck!
Rizee College Team`
  },
  ADMISSION_CONFIRMED: {
    subject: "Congratulations! Admission Confirmed - Rizee College",
    message: `Dear {student_name},

We are pleased to inform you that your admission to Rizee College has been confirmed. 

Welcome to the Rizee family! Our team will reach out to you shortly for the next steps.

Best Regards,
Admissions Department`
  }
};

export const triggerEmail = async (client, { student, type, customData = {} }) => {
  let emailData = {
    to: student?.student_email || student?.email,
    subject: customData.subject || "Important Update - Rizee College",
    message: customData.message || ""
  };

  if (type === 'TEST_ASSIGNED') {
    const tpl = EMAIL_TEMPLATES.TEST_ASSIGNED;
    emailData.subject = tpl.subject;
    emailData.message = tpl.message
      .replace(/{student_name}/g, student.student_name)
      .replace(/{username}/g, student.student_mobile)
      .replace(/{password}/g, student.admission_test_password || '123456');
  } else if (type === 'ADMISSION_CONFIRMED') {
    const tpl = EMAIL_TEMPLATES.ADMISSION_CONFIRMED;
    emailData.subject = tpl.subject;
    emailData.message = tpl.message.replace(/{student_name}/g, student.student_name);
  }

  try {
    const { data } = await client.mutate({
      mutation: SEND_EMAIL_MUTATION,
      variables: {
        params: {
          to: emailData.to,
          subject: emailData.subject,
          message: emailData.message
        }
      }
    });
    return data.sendEmail.success;
  } catch (err) {
    console.error("Failed to trigger email:", err);
    return false;
  }
};
